import React, { useState,useEffect } from 'react';

import { useSelector } from 'react-redux';
import dooctilogo from "../assets/images/Dooctilogo.svg";
import person from "../assets/images/person.svg";
import Sidebar from './Sidebar.js'; // Import the Sidebar component
import "../assets/css/comtemplete.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faBars } from '@fortawesome/free-solid-svg-icons'; // Icon for sidebar toggle

function Comtemplete(props) {
    const { children, toggleUserOptions, badge, logout, handleSetBadge, awayOptionsOpen ,waitingCalls} = props
    const [isSidebarOpen, setIsSidebarOpen] = useState(false); // State for sidebar
    const [logo,setLogo] = useState()
    const backgroundstate = useSelector((state) => state.bgpermission);
    const queuestatus = JSON.parse(localStorage.getItem('queuelogin'));
    const liveagentdata = localStorage.getItem('liveagentdata')
    const waitingCallsView = () =>{
        props.viewWaitingCalls(true)
    }
    let config = null;
 
    try {
        const storedConfig = localStorage.getItem("config");
        if (storedConfig) {
          const parsedConfig = JSON.parse(storedConfig);
          config = parsedConfig?.projects?.[0] || null;
        }
      } catch (error) {
        console.error("Failed to parse config from localStorage:", error);
      }
      
      const waitingCallGrab = config?.userPermission?.waiting_call_grab;
 
 
    // console.log(config,"LLLLLLLLLLLLLLLLL",waitingCallGrab)
    useEffect(() => {
        const baseURL = window.location.hostname;
        const parts = baseURL.split('.');
        const domain = parts.length >= 3 ? parts[parts.length - 2] : parts[0];

        if (domain === 'localhost') {
            setLogo(dooctilogo);
            return;
        }

        fetch(`https://api-v2.doocti.com/${domain}`)
            .then((response) => response.json())
            .then((result) => {
                if (result?.statusCode === 200 && result?.data?.[0]?.logo) {
                    setLogo(result.data[0].logo);
                }
            })
            .catch((error) => {
                console.error("Failed to fetch company logo:", error);
            });
    }, []);
  

    // const toggleSidebar = () => {
    //     setIsSidebarOpen(!isSidebarOpen);
    // };

    return (
        <div>
            <div className='topheader'>
                <header className="header-top dropshadow">
                    <div className="header-content">
                        <img className="logo-image" src={logo} alt="Logo" />
                        {/* <button className="sidebar-toggle" onClick={toggleSidebar}>
                            <FontAwesomeIcon icon={faBars} />
                        </button> */}
                            <div>
                                <div className="button-logout">
                                {(liveagentdata == "READY" || liveagentdata == "PAUSE") && (
                                    <>
                                    <div className="betweenspace">
                                        <div className="user-options" id="userOptions">
                                            {/* Render Online option if awayOptionsOpen is true */}
                                            {(awayOptionsOpen) ? (
                                                <div className="option" id="onlineOption" onClick={() => handleSetBadge('Online')}>
                                                    Online
                                                </div>
                                            ) : (
                                                <div className="badge-grey">
                                                    <div className="away-options">
                                                        {/* Render away options dynamically */}
                                                        {['Lunch', 'Meeting', 'Break'].map((option) => (
                                                            <div className="option" key={option} onClick={() => handleSetBadge(option)}>
                                                                {option}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <img className="userlogo" src={person} title="Agent Status" onClick={toggleUserOptions} />
                                        {/* {badge === 'Online' && <div className="badge-green"></div>} */}
                                        {/* {badge === 'Offline' && <div className="badge-red"></div>} */}
                                        {/* {awayOptionsOpen && <div className="badge-grey"></div>} */}

                                        {liveagentdata == "READY" ? (

                                            <div className="badge-green"></div>
                                        ) : (
                                            <div className="badge-grey"></div>
                                        )}

                                    </div>
                                    <button className="userlogout" onClick={logout} style={{ color: 'white', border: 'none', fontSize: '18px',cursor:"pointer" }}>
                                        <FontAwesomeIcon title="Logout" icon={faPowerOff} />
                                    </button>
                                    </>)}
                                    {(liveagentdata == "READY" || liveagentdata == "PAUSE" || liveagentdata == "DISPO")  && waitingCallGrab && <button
                                        className={`callWaiting ${(liveagentdata == "CONNECT" || liveagentdata == "DISPO" || liveagentdata == "PAUSE" || waitingCalls?.length === 0 ) ? "disablebtn" : ""}`} style={{ color: 'white', border: 'none', fontSize: '18px' }}
                                        onClick={()=>waitingCallsView()}
                                        >
                                        <FontAwesomeIcon icon={faPhone} />
                                        {waitingCalls?.length > 0 && (
                                            <span className='callWaitingCount' style={{
                                                position: 'absolute',
                                                top: '-5px',
                                                right: '-10px',
                                                backgroundColor: 'red',
                                                color: 'white',
                                                borderRadius: '50%',
                                                padding: '2px 6px',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                            }}>{waitingCalls.length}</span>
                                        )}
                                    </button>}
                                </div>
                            </div>
                    </div>
                </header>
            </div>
            {/* <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} /> */}
            <div className='contentspace'>
                {children}
            </div>
        </div>
    );
}

export default Comtemplete;
